/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Width_LabelInputs */



/**
* | output |
* | --- |
* | "Display Width (Characters)" |
*
* @param {Options_Display_Width_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_width_label = /** @type {((inputs?: Options_Display_Width_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Width_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Largeur d'affichage (caractères)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigebreite (Zeichen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Larghezza di visualizzazione (caratteri)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ширина отображения (символов)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ancho de pantalla (caracteres)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示宽度（字符）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示幅（文字数）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिस्प्ले की चौड़ाई (अक्षर)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Largura de exibição (caracteres)")
	return /** @type {LocalizedString} */ ("Display Width (Characters)")
});